import { Col, Divider, Row } from 'antd';
import type { FC } from 'react';
import FormInput from '../../../../../components/Inputs/FormInput';
import SecondaryLabel from '../../../../../components/Labels/SecondaryLabel';
import ClaimsSettingsCarrierAddressForm from './ClaimsSettingsCarrierAddressForm';

const ClaimsSettingsCarrierForm: FC = () => {
  return (
    <div>
      <Row gutter={15}>
        <Col md={6}>
          <FormInput editMode label="Claim Mgr" margin="mb-10" />
          <FormInput editMode label="Release Amount" margin="m-0" inputType="number" />
        </Col>
        <Col md={6}>
          <FormInput editMode label="Threshhold Amount" margin="mb-10" inputType="number" />
          <FormInput editMode label="Maximum Liability Amount" margin="m-0" inputType="number" />
        </Col>
        <Col md={6}>
          <FormInput editMode label="Deductible Amount" margin="mb-10" inputType="number" />
          <FormInput editMode label="Claim Limit" margin="m-0" inputType="number" />
        </Col>
        <Col md={6}>
          <FormInput editMode label="Suit Limit" margin="mb-10" inputType="number" />
          <FormInput editMode label="Grace Period (in Days)" margin="m-0" inputType="number" />
        </Col>
      </Row>
      <Row className="mt-10" gutter={15}>
        <Col md={12}>
          <Row className="my-5" gutter={15} align="middle">
            <Col>
              <SecondaryLabel>Overcharge Claim Address</SecondaryLabel>
            </Col>
            <Col className="flex-1 pt-3">
              <Divider className="m-0 border-top-border" />
            </Col>
          </Row>
          <ClaimsSettingsCarrierAddressForm />
        </Col>
        <Col md={12}>
          <Row className="my-5" gutter={15} align="middle">
            <Col>
              <SecondaryLabel>Loss and Damage Claim Address</SecondaryLabel>
            </Col>
            <Col className="flex-1 pt-3">
              <Divider className="m-0 border-top-border" />
            </Col>
          </Row>
          <ClaimsSettingsCarrierAddressForm />
        </Col>
      </Row>
    </div>
  );
};

export default ClaimsSettingsCarrierForm;
